import React from 'react';

interface Props {
  header: React.ReactNode;
  subheader?: React.ReactNode;
}

export const MenuSectionHeader = ({ header, subheader }: Props) => (
  <div className="flex flex-col">
    <span className="flex flex-row gap-1 align-middle">
      <span className="block max-w-36 truncate font-medium text-primary">
        {header}
      </span>
    </span>
    <span className="block max-w-36 truncate text-sm font-normal text-secondary">
      {subheader}
    </span>
  </div>
);
